export enum EnrollmentState {
    Active = "active",
    Completed = "completed",
    Inactive = "inactive",
    Invited = "invited",
    Unknown = "unknown",
    Deleted = "deleted"
}
